import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "There is no do or do not, only try",
  "description": "",
  "published": "2012-04-24T00:00:00.000Z",
  "redirect_from": ["/blog/there-is-no-do-or-do-not-only-try/swizec/4239"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`No. Try not. Do... or do not. There is no try.`}</p>
      <p parentName="blockquote"><img parentName="p" {...{
          "src": "https://images.wikia.com/starwars/images/e/e0/Yoda_SWSB.jpg",
          "alt": "A green guy",
          "title": "A green guy"
        }}></img></p>
      <p parentName="blockquote">{`~ Some Green Dude`}</p>
    </blockquote>
    <p>{`That's solid advice right there. You shouldn't `}<em parentName="p">{`try`}</em>{` to do this. Just do it. Or don't, if you decide it you don't want to for whatever reason.`}</p>
    <p>{`Another movie had a similar philosophy: `}<em parentName="p">{`"You either `}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Karate",
          "title": "Karate"
        }}>{`karate`}</a>{` or you do not karate. Karate so so. You beat up."`}</em></p>
    <p>{`Here's the thing though, that advice is absolute `}<strong parentName="p">{`bollocks.`}</strong>{` We live in a probabilistic universe - even if you `}<em parentName="p">{`do`}</em>{` do instead of try, you are at the mercy of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Probability",
        "title": "Probability"
      }}>{`probability`}</a>{`.`}</p>
    <p>{`Our actions are `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Stochastic",
        "title": "Stochastic"
      }}>{`stochastic`}</a>{`, so are the actions of others. Even the basic physical forces acting on things are ... stochastic. Ever studied the development of robots? Most of it goes into dealing with probabilistic actions in a probabilistic universe.`}</p>
    <p>{`Most of the time when we "do instead of try" we aren't even dealing with just ourselves, there are many moving pieces. People even. With their own stochastic thoughts and decisions.`}</p>
    <p>{`Whenever you decide to `}<strong parentName="p">{`do`}</strong>{` what you're really doing is something more like: `}<em parentName="p">{`"Okay, I will do everything within reason to achieve this. If more information reveals it isn't worth the effort, I won't. If something more important comes up, I won't."`}</em></p>
    <p>{`Sure, commit yourself fully, but remember you're only `}<em parentName="p">{`trying and hoping for the best`}</em>{`.`}</p>
    <lite-youtube {...{
      "videoid": "PHDT30oWs20",
      "videostartat": "0"
    }}></lite-youtube>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://wmbriggs.com/blog/?p=5117"
        }}>{`All Of Statistics: Part I`}</a>{` (wmbriggs.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.technologyreview.com/blog/arxiv/27598/"
        }}>{`Stochastic Pattern Recognition Dramatically Outperforms Conventional Techniques`}</a>{` (technologyreview.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://channel9.msdn.com/Events/Lang-NEXT/Lang-NEXT-2012/Reverend-Bayes-meet-Countess-Lovelace-Probabilistic-Programming-for-Machine-Learning"
        }}>{`Reverend Bayes, meet Countess Lovelace: Probabilistic Programming for Machine Learning`}</a>{` (channel9.msdn.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.machinedlearnings.com/2012/02/active-learning-and-contextual-bandits.html"
        }}>{`Active Learning and Contextual Bandits`}</a>{` (machinedlearnings.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=fe347ba2-460e-43ca-9458-543f6f144f40",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      